import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {withTranslation} from 'react-i18next';
import {eventBus, streamHook} from '../../data/Streams';
const stream = require('stream-browserify');
const tokenize = require('md-tokenizer');
import marked from '../../utils/marked';
import {connectStream} from '../../lib/bastetjs/utils/connectStream';
import {styles} from './styles';
import {Location} from '../shared/Location';
import {DateTime} from '../shared/DateTime';
import {_date} from '../../utils/date';
import { configs } from '../../configs';

function tokens({event = {}}) {
  const streamId = 'MarkdownTokens';
  const tokenStream = streamHook(streamId, []);
  const desc = String(event.extendedDescription || '');

  if (desc.length) {
    const chars = stream.PassThrough.apply();
    chars.write(desc);
    chars.end();

    let tokens = [];
    chars.pipe(tokenize((src, token) => {
      tokens.push({type: token.type, src});
      chars._readableState.flowing || eventBus.publish(streamId, tokens);
    }));
  }

  return tokenStream;
}


class EventSummaryComponent extends Component {
  static propTypes = {
    t: PropTypes.func
  };

  static defaultProps = {
    tokens: [],
    event: {},
  };

  constructor(props) {
    super(props);
    this.state = {more: false};
    this.clickMore = this.clickMore.bind(this);
  }

  clickMore() {
    this.setState({more: !this.state.more});
  }

  renderExtended() {
    if (this.props.tokens.length) {
      const reduced = this.props.tokens.reduce((map, token) => {
        if (token.type === 'new line') {
          map.chunks[++map.idx] = null;
        }
        else {
          const text = map.last === 'new line'
            ? token.src.replace(/^\s+/, '')
            : token.src;
          map.chunks[map.idx] = String(map.chunks[map.idx] || '') + text;
        }

        map.last = token.type;
        return map;
      }, {idx: 0, chunks: [null], last: null});

      const divs = reduced.chunks.map((chunk, i) => {
        return chunk !== null && chunk !== ''
          ? (<div key={i} dangerouslySetInnerHTML={{__html: marked(chunk)}}/>)
          : (<div key={i} style={{height: '1em'}}/>);
      });

      return (<div style={{marginTop: '8px'}} id={'extended-description'}>{divs}</div>);
    }

    return null;
  }

  renderExtendedWithControls() {
    const {
      t
    } = this.props;

    if (this.state.more) {
      return (
        <div>
          {this.renderExtended()}
          <div style={{marginTop: '8px'}}>
            <div style={styles.link} onClick={this.clickMore} id={'elp-hide-button'}>
              {t('Hide')}
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div style={styles.moreButtonWrap}>
          <div style={styles.link} onClick={this.clickMore}
               id='elp-read-more-button'>
            {t('Read more')}
            <img style={styles.moreImg} src={`${configs.bragiUrl}/svg/down-chevron-blue.svg`} />
          </div>
        </div>
      );
    }
  }

  // TODO: Check the various 'renders()' here. Optimize...

  renderDesc() {
    const {
      event = {},
      isMobile,
    } = this.props;

    const {
      isPublishedAthlinks,
      description,
      extendedDescription
    } = event;

    if (!isPublishedAthlinks) return;

    if (description && extendedDescription) {
      return (
        <div itemProp="description" style={styles.descContainer(isMobile)} >
          {description}
          {this.renderExtendedWithControls()}
        </div>
      );
    } else {
      return (
        <div itemProp="description" style={styles.descContainer(isMobile)} >
          {extendedDescription ?
            this.renderExtended()
            :
            description
          }
        </div>
      );
    }
  }

  render() {
    const {
      event = {},
      fetching = false
    } = this.props;

    const {
      name = '',
      startTime,
      location = {},
    } = event;

    const startDate = _date(startTime);
    const state = location.regionId ? location.regionId.split('-') : [];

    return (
      <div>
        <h2 id='event-name' style={styles.title}>
          {name}
          <div style={styles.loadingTitle(fetching)}/>
        </h2>

        <div style={styles.detailRow}>
          <div style={styles.dateContainer}>
            <DateTime
              date={startDate}
              showTime={false}
              icon={null}/>
          </div>
          <div style={{display:'inline-block'}}>
            <Location
              city={location.city}
              state={location.region ? location.region : state[1] || ''}
              country={location.countryId}
              searchType={null}
              icon={null}
              style={styles.locationCell}
            />
          </div>

          <div style={styles.loadingDetails(fetching)}/>
        </div>

        {this.renderDesc()}

      </div>
    );
  }
}

export const EventSummary = withTranslation()(connectStream({tokens})(EventSummaryComponent));



/** WEBPACK FOOTER **
 ** ./components/eventSummary/EventSummary.js
 **/